var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParentIssue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#6B6F76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.333 3.167c-1.196 0-2.166.97-2.166 2.166v5.5c0 1.197.97 2.167 2.166 2.167h1.165c.172.412.385.803.634 1.167H5.333A3.333 3.333 0 012 10.833v-5.5A3.333 3.333 0 015.333 2h5.5c1.43 0 2.649.9 3.123 2.164A6.519 6.519 0 0012.54 4a2.163 2.163 0 00-1.708-.833h-5.5zm9.465 5.61a.298.298 0 00-.038-.32L12.806 6.05a.304.304 0 00-.462-.01l-2.187 2.449a.303.303 0 00.229.504l1.07-.01c-.115 3.735-3.093 4.39-3.123 4.396a.304.304 0 00-.252.302v.024a.303.303 0 00.307.276c.051 0 5.171-.223 5.331-5.021l.808-.008a.304.304 0 00.271-.175z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentIssue);
export default __webpack_public_path__ + "static/media/parent-issue.a1f53ea2.svg";
export { ForwardRef as ReactComponent };